import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as DropdownIcon } from '../../assets/images/svg/dropdown-indicator.svg';
import themeColors from '../../assets/styles/themeColors';

const DropdownIconStyled = styled(DropdownIcon)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const DropdownIndicator = (props) => <DropdownIconStyled {...props} />;

DropdownIndicator.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

DropdownIndicator.defaultProps = {
  w: '12px',
  h: '8px',
};

export default DropdownIndicator;
